import React, { useState, useEffect, useContext } from "react";
import { MicrosoftLoginForm } from "./MicrosoftLogin";
import { CustomParseSafeHtml, RemoveAllCookies } from "../../JS/Common";
import { LazyLoadImage } from "react-lazy-load-image-component";
import GoogleOauth from "../../Components/GoogleOauth";
import { Carousel } from "react-bootstrap";
import useConfig from "../../Hooks/useConfig";

export function Login() {
  const { signin_slides_dots, terms_service_link, privacy_policy_link, show_login_msg,
    new_features_link, signin_slides, system_status, demo_url, secondary_text, logo } = useConfig();
  const [AlertMsgs, setAlertMsgs] = useState("");
  const [AlertColor, setAlertColor] = useState("");
  const [isImageLoading ,setIsImageLoading] = useState(true);
    
  useEffect(() => {
    RemoveAllCookies();
  }, []);
  const slides = signin_slides || [];

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <React.Fragment>
      <LazyLoadImage
        src="/images/LoginBg.png"
        alt=""
        className="MainDiv-bg-image"
      />
      <div className="row align-items-center" style={{ height: "100vh" }}>
        <div className="col-md-5 pe-0 offset-md-1 col-12 position-relative">
          <div className="p-3 m-1 text-center card-wrapper ">
            <div style={{ color: `${AlertColor}` }} className="font-16">
              {CustomParseSafeHtml(AlertMsgs)}
            </div>
            <div className="col-12 my-4 px-3">
              <img
                src={logo}
                className={`img-fluid ${isImageLoading ? "d-none" : ""}`}
                alt="Logo"
                loading="eager"
                onLoad={()=> setIsImageLoading(false)}
              />
            </div>
            <h2 className="fw-semibold my-3">Welcome Back!</h2>
            <label className="mb-2 font-13 text-center">
              New to {secondary_text}?<br />
              <a
                className="ps-2 cursor-pointer schoolColorStatus"
                href="/register"
              >
                Create an account, it's free.
              </a>
            </label>
            <div className="col-md-10 offset-md-1 text-center mt-3">
              <GoogleOauth
                alertmsg={setAlertMsgs}
                alertcolor={setAlertColor}
                flag="signin"
              />
            </div>
            <div className="col-12 text-center py-3">
              <img src="/images/NewLoginOr.svg" className="img-fluid" />
            </div>
            <div className="col-md-10 offset-md-1 text-center">
              <MicrosoftLoginForm
                alertmsg={setAlertMsgs}
                alertcolor={setAlertColor}
              />
            </div>
            <div className="row pt-3">
              <div className="col-md-6 ps-md-5  text-center text-nowrap">
                <a
                  className="ps-2 cursor-pointer font-13 schoolColorStatus"
                  href={system_status}
                  target="_blank"
                >
                  View System Status
                </a>
              </div>
              <div className="col-md-6 text-center pe-md-5 text-nowrap">
                <a
                  className="cursor-pointer font-13 schoolColorStatus"
                  href={demo_url}
                  target="_blank"
                >
                  Request a Demo
                </a>
              </div>
              {show_login_msg && (
                <div className="col-12 px-4">
                  <div className="mt-3 text-start ps-3 p-1" style={{ fontSize: "12px", borderLeft: "1px solid var(--error_text_color)", background: "#f9fafb" }}>
                    <label className="mb-2">
                      <b className="text-black">Note:</b> Effective immediately, repairs can now be processed through Bluum's Rocket Portal - a powerful new tool that provides repair management, asset management and help desk ticketing for your entire device fleet - at no cost to you.
                    </label>
                    <br />
                    If you haven't received your Rocket Portal login information, email <a className="schoolColorStatus" href="mailto:service@bluum.com" style={{ color: "inherit" }}><u>service@bluum.com</u></a>, and we'll help you get your account set up.
                  </div>
                </div>
              )}
              <div className={`col-12 text-center ${show_login_msg ? 'mt-3' : 'mt-5'} font-13`}>
                By proceeding, you agree to the <br />
                <a
                  className="cursor-pointer"
                  style={{ color: "black", textDecoration: "underline" }}
                  href={terms_service_link}
                  target="_blank"
                >Terms of Service</a> and &nbsp;
                <a
                  className="cursor-pointer"
                  style={{ color: "black", textDecoration: "underline" }}
                  href={privacy_policy_link}
                  target="_blank"
                >Privacy Policy.</a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12 px-0 position-relative ">
          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            controls={false}
            indicators={false}
          >
            {slides?.map((item, index) => (
              <Carousel.Item key={index}>
                <div className="d-flex flex-column justify-content-center  align-items-center">
                  <img src={item.image} className="img-fluid " alt={`${item.image}`} title={item.caption} />
                  <p className="m-0 p-0 fs-4 fw-semibold text-center  w-100">
                    {item.caption}
                  </p>
                  {item.smallcaption &&
                    <label>
                      {item.smallcaption}{" "}
                      <a
                        className="cursor-pointer"
                        style={{ color: "var(--primary-color)", textDecoration: "underline" }}
                        href={new_features_link}
                        target="_blank"
                      >
                        here
                      </a>
                    </label>
                  }
                </div>

              </Carousel.Item>
            ))}
          </Carousel>
          <div className="custom-indicators">
            {signin_slides_dots && signin_slides_dots?.map((idx) => (
              <span
                key={idx}
                className={`carousel-dot-css ${index === idx ? "active" : ""}`}
                onClick={() => setIndex(idx)}
              />
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
